module.exports = "<a>\n\t<span class=\"icon\" aria-hidden=\"true\" ng-class=\"vm.icon\"></span>\n\t<span class=\"sr-only\">{{::vm.icon}}</span>\n</a>"


//////////////////
// WEBPACK FOOTER
// ./app/components/tableGridIconCell/tableGridIconCell.html
// module id = 336
// module chunks = 1